import gql from "graphql-tag";

const GET_HOMEOWNER_ON_EDIT = gql`
  query getHomeOwnerOnEdit(
    $limit: Int
    $pageNum: Int
    $filter: HomeOwnersFilter
    $search: String
    $order: [String]
  ) {
    getAllHomeOwners(
      limit: $limit
      pageNum: $pageNum
      filter: $filter
      search: $search
      order: $order
    ) {
      Home_Owner {
        id
        customer_id
        first_name_1
        last_name_1
        first_name_2
        last_name_2
        cell_phone_1
        cell_phone_2
        primary_email_1
        primary_email_2
        secondary_emails_1
        secondary_emails_2
        primary_email_1_status
        primary_email_2_status
        street_address
        city
        state{
          id
          name
        }
        zip
        realtor{
          id
          first_name
          last_name
        }
        customer_origination_area{
          id
          name
        }
      }
    }
  }
`;
export default GET_HOMEOWNER_ON_EDIT;
